
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import { useAnimationSimplifier } from "@/hooks/use-animation-simplifier";

interface FloatingCardProps {
  className?: string;
  children?: React.ReactNode;
  delay?: number;
}

export const FloatingCard = ({ className, children, delay = 0 }: FloatingCardProps) => {
  const { shouldSimplifyAnimations, animationDuration } = useAnimationSimplifier();
  
  return (
    <motion.div
      className={cn(
        "bg-white/60 backdrop-blur-sm border border-brand-accent/30 rounded-lg shadow-lg hover:shadow-xl hover:shadow-brand-primary/20 p-4 md:p-6 transform-gpu transition-all duration-300",
        className
      )}
      initial={{ y: 20, opacity: 0 }}
      animate={shouldSimplifyAnimations ? { 
        opacity: 1,
        y: 0 
      } : { 
        y: [0, -10, 0],
        opacity: 1,
      }}
      transition={{
        y: {
          delay: delay,
          duration: shouldSimplifyAnimations ? animationDuration : 4,
          repeat: shouldSimplifyAnimations ? 0 : Infinity,
          ease: "easeInOut",
        },
        opacity: {
          duration: animationDuration,
        }
      }}
      whileHover={!shouldSimplifyAnimations ? {
        y: -5,
        boxShadow: "0 20px 40px rgba(97, 46, 215, 0.15)",
        borderColor: "rgba(132, 102, 218, 0.3)",
        transition: { duration: 0.3 }
      } : undefined}
    >
      {children}
    </motion.div>
  );
};
